
/* injects from baggage-loader */
require('./html-textarea.component.html');

import angular from 'angular'
import $ from 'jquery'
import { OpportunitiesModule } from '../core/opportunities.module'
import '../scripts/redactor'

OpportunitiesModule.component('htmlTextarea', {
    templateUrl: '/app/components/html-textarea.component.html',
    controller: HtmlTextareaController,
    bindings: {
        textValue: '@',
        onEdit: '&'
    }
})

function HtmlTextareaController($element, apiUrls, logger) {
    "ngInject";

    var $ctrl = this;
    $ctrl.$onChanges = $onChanges;
    $ctrl.onUpdate = onUpdate;

    function $onChanges(changes) {
        if (changes.textValue) {
            let redactor = getRedactor();
            redactor.set($ctrl.textValue);
        }
    }

    function onUpdate() {
        let redactor = getRedactor();
        var data = redactor.get();
        if (data != "")
            $ctrl.onEdit({action:data});
    }

    function getRedactor() {
        return $ctrl.redactor = $ctrl.redactor || createRedactor();
    }
    
    function createRedactor() {        
        const textArea = $element.find('.editor').redactor({
            linebreaks: true,
            buttons: ['html', 'formatting', 'bold', 'italic', 'image', 'unorderedlist', 'orderedlist', 'outdent', 'indent', 'table', 'link', 'mergeField', 'alignment', 'horizontalrule'],
            plugins: ['button', 'layout', 'fontsize', 'fontfamily', 'fontcolor', 'mergeField'],
            imageUpload: apiUrls.alertMiner + '/api/FileUpload/UploadImage',
            initCallback: function () {
                ensureMergeFieldPlugin(this);
                ensureMergeFieldButton(this);
                setTimeout(() => {
                    ensureMergeFieldButton(this);
                }, 50);
            },
            changeCallback: 
                function () {
                    $ctrl.textValue = this.get();
                    $ctrl.onEdit({action:$ctrl.textValue});
                },
            uploadErrorCallback:
                function (data) {                    
                    logger.warning("uploadFailedErrorMsg");
                }
        });

        const redactor = textArea.data('redactor');
        ensureMergeFieldPlugin(redactor);
        ensureMergeFieldButton(redactor);

        return redactor;
    }

    function ensureMergeFieldPlugin(redactor) {
        if (redactor.__mergeFieldInitialized) {
            return;
        }

        const mergeFieldPlugin = window.RedactorPlugins && window.RedactorPlugins.mergeField;
        if (mergeFieldPlugin) {
            Object.assign(redactor, mergeFieldPlugin);
            if (typeof mergeFieldPlugin.init === 'function') {
                mergeFieldPlugin.init.call(redactor);
            }
        } else {
            attachMergeFieldHandlers(redactor);
            initMergeFieldHandlers(redactor);
        }

        redactor.__mergeFieldInitialized = true;
    }

    function ensureMergeFieldButton(redactor) {
        if (!redactor.buttonGet || redactor.buttonGet('mergeField').length > 0) {
            return;
        }

        const handler = function () {
            if (typeof redactor.mergeFieldToolbarButtonClick === 'function') {
                return redactor.mergeFieldToolbarButtonClick.apply(redactor, arguments);
            }

            return null;
        };

        redactor.buttonAddAfter('fontcolor', 'mergeField', 'Insert Merge Field', handler);

        if (redactor.buttonGet('mergeField').length === 0 && redactor.$toolbar) {
            const $button = $('<a href="javascript:;" title="Insert Merge Field" tabindex="-1" class="aa-merge-field-btn">Insert Merge Field</a>');
            $button.on('click', (e) => {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                if (typeof redactor.mergeFieldToolbarButtonClick === 'function') {
                    redactor.mergeFieldToolbarButtonClick();
                }
            });
            redactor.$toolbar.append($('<li>').append($button));
        }
    }

    function attachMergeFieldHandlers(redactor) {
        redactor.mergeFieldToolbarButtonClick =  () => {
            this.selectionSave();
            this.modalInit('Insert Merge Field', mergeFieldModalContent(), 320, $.proxy(function () {
                $('#redactor_insert_merge_field_btn').click($.proxy(this.mergeFieldInsert, this));
                $.ajax({
                    type: 'GET',
                    url: '/Settings/OutreachTemplates/MergeFields',
                    data: {},
                    success: (data) => {
                        $('#redactor-modal-merge-field-insert').html(data);
                        $('option', '#MergeFields').dblclick(() => {
                            $('#redactor_insert_merge_field_btn').click();
                        });
                    }
                });
            }, this));
        };

        redactor.mergeFieldInsert = function () {
            var key = $('#MergeFields').val();
            var displayText = $('#MergeFields option:selected').text();
            if (key !== null) {
                const html = `<span contenteditable="false" class="aa-merge-field" data-merge-field-key="${key}">{{${displayText}}}</span>`;
                this.bufferSet(false);

                var parent = this.getParent();
                if (parent && $(parent).hasClass('aa-merge-field')) {
                    $(parent).remove();
                }

                this.selectionRestore();
                this.insertHtmlAdvanced(html, true);
            }
            this.modalClose();
        };

        redactor.mergeFieldTooltip = ($mergeField) => {
            const pos = $mergeField.offset();
            const tooltip = $('<span class="redactor-mergefield-tooltip"></span>');
            const aDelete = $(`<a href="#">${this.opts.curLang._delete}</a>`).on('click', $.proxy((e) => {
                e.preventDefault();
                this.bufferSet(false);
                $mergeField.remove();
                this.sync();
            }, this));
            const aEdit = $(`<a href="#">${this.opts.curLang.edit}</a>`).on('click', $.proxy(this.mergeFieldToolbarButtonClick, this));
            tooltip.append(aDelete);
            tooltip.append(' | ');
            tooltip.append(aEdit);
            tooltip.css({
                top: `${pos.top + 20}px`,
                left: `${pos.left}px`
            });
            $('.redactor-mergefield-tooltip').remove();
            $('body').append(tooltip);
        };

        redactor.mergeFieldTooltipHide = () => {
            $('.redactor-mergefield-tooltip').remove();
        };
    }

    function initMergeFieldHandlers(redactor) {
        redactor.buttonAdd('mergeField', 'Insert Merge Field', redactor.mergeFieldToolbarButtonClick);
        redactor.$editor.on('click', '.aa-merge-field', () => {
            redactor.mergeFieldTooltip($(this));
            return false;
        });
        redactor.$editor.on('hover', '.aa-merge-field', (e) => {
            var $that = $(this);
            $that.toggleClass('ui-cursor-hand');
            if (e.type === 'mouseenter') {
                $that.css('background-color', '#d0e5f5');
            } else {
                $that.removeAttr('style');
            }
        });
        $(document).on('click.redactor-mergeField-hide', $.proxy(redactor.mergeFieldTooltipHide, redactor));
        redactor.$editor.on('click.redactor-mergeField-hide', $.proxy(redactor.mergeFieldTooltipHide, redactor));
        $(document).on('keydown.redactor-mergeField-hide', $.proxy(redactor.mergeFieldTooltipHide, redactor));
    }

    function mergeFieldModalContent() {
        return '<section id="redactor-modal-merge-field-insert">'
            + '<em>Loading...</em>'
            + '</section>'
            + '<footer>'
            + '<button class="redactor_modal_btn redactor_btn_modal_close">Cancel</button>'
            + '<button class="redactor_modal_btn redactor_modal_action_btn" id="redactor_insert_merge_field_btn">Insert</button>'
            + '</footer>';
    }
}
